module.exports = __webpack_public_path__ + "static/media/cw.352ab7a1.webp";